// extracted by mini-css-extract-plugin
export default {"container":"chezro_container__XZppm","img_container":"chezro_img_container__f7wEX"};